import React from 'react';
import AutocompleteInput from './AutocompleteInput';

export default ({ handleCancelClick, handleSubmitSuccess, initialValue }) => {
    const [touched, setTouched] = React.useState(false);
    const [inputValue, setInputValue] = React.useState('');
    React.useEffect(() => {
        setInputValue(initialValue || '');
    }, [initialValue])
    function handleSubmit() {
        setTouched(true);
        if (inputValue) {
            handleSubmitSuccess(inputValue);
        }
    }
    return (
        <div>
            <AutocompleteInput 
                placeholder="Enter a delivery location" 
                field={{value: inputValue, onChange: (e) => setInputValue(e.target.value), name: "location"}} 
                setFieldValue={(name, value) => setInputValue(value)}
                invalid={touched && !inputValue}
                blurAction={() => setTouched(true)}
            />
            {touched && !inputValue && <p className='error-msg alt-marg'>Please enter a valid address</p>}
            <div className='save-btn-container margin-bottom-1'>
                {handleCancelClick&& <div>
                    <button type="button" className='btn white-btn small-btn' onClick={handleCancelClick}>CANCEL</button>
                </div>}
                <div>
                    <button
                        onClick={handleSubmit}
                        type="submit" 
                        className={`btn small-btn primary-outline-btn`} 
                    >
                        SAVE ADDRESS
                    </button>
                </div>
            </div>
        </div>
    )
}